import { TableRow } from "../Table/Table.interface";

export const CREATE_FORM_ID = "createPreset";
export const UPDATE_FORM_ID = "updatePreset";
const PRESET_TABLE_HEADERS = ["Название", "FPS", "Разрешение", "Битрейт видео", "Битрейт аудио"];
export const TABLE_ROW_GAP_HEIGHT = 10;
export const DEFAULT_TABLE_ROW: TableRow = {
  transcodePresetId: 0,
  items: [
    { value: "default" },
    { value: 35 },
    { value: "0000x0000" },
    { value: 35 },
    { value: 120 }
  ]
};

export const getTableHeaders = (isMobile: boolean) => {
  return isMobile ? [] : PRESET_TABLE_HEADERS;
};